/**
 * @generated SignedSource<<b12cc280b38f30840847599e305b10b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachmentConnectionFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly cursor: string;
    readonly node: {
      readonly order: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"AttachmentFragment">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly pageInfo: {
    readonly " $fragmentSpreads": FragmentRefs<"PageInfoFragment">;
  } | null | undefined;
  readonly " $fragmentType": "AttachmentConnectionFragment";
};
export type AttachmentConnectionFragment$key = {
  readonly " $data"?: AttachmentConnectionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttachmentConnectionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AttachmentConnectionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AttachmentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cursor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Attachment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "order",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AttachmentFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PageInfoFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AttachmentConnection",
  "abstractKey": null
};

(node as any).hash = "f45b16e7c7a2d91ee3b5120d4634a233";

export default node;
